module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Navigation/messageIcon-bb6dc4ec09fb8f1c8d633691fc4f55da.svg";